import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectLangComponent } from './common/components/select-lang/select-lang.component';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { AccountCreatedComponent } from './modules/account/confirm-registration/account-created/account-created.component';
import { ConfirmRegistrationComponent } from './modules/account/confirm-registration/confirm-registration.component';
import { CreateAccountComponent } from './modules/account/create-account/create-account.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { NewPasswordComponent } from './modules/account/forgot-pwd/new-password/new-password.component';
import { ResetPwdComponent } from './modules/account/forgot-pwd/new-password/reset-pwd/reset-pwd.component';
import { LoginComponent } from './modules/account/login/login.component';
import { HomeComponent } from './modules/home/home.component';
import { AssetLibraryComponent } from './modules/asset-library/asset-library.component';
import { CreateProfileComponent } from './modules/create-profile/create-profile.component';
import { UsersComponent } from './modules/users/users/users.component';
import { MyAccountComponent } from './modules/account/my-account/my-account.component';
import { DevicesComponent } from './modules/devices/devices/devices.component';
import { IposHelpComponent } from './modules/ipos-help/ipos-help.component';
import { ChangeLanguageComponent } from './modules/account/change-language/change-language.component';
import { StandardDownloadComponent } from './modules/profile/standard-download/standard-download.component';
import { OemPortalComponent } from './modules/oem-portal/oem-portal.component';
import { NewModelSkuComponent } from './modules/oem-portal/new-model-sku/new-model-sku.component'
import { PartnerContentComponent } from './modules/partner-content/partner-content/partner-content.component';
import { NewPartnerContentComponent } from './modules/oem-portal/new-partner-content/new-partner-content.component';
import { SkuIdsComponent } from './modules/sku-ids/sku-ids.component';
import { GameDemosComponent } from './modules/account/game-demos/game-demos.component';
import { ProfileTabsComponent } from './modules/profile/profile-tabs/profile-tabs.component';
import { TwoFAComponent } from './modules/account/forgot-pwd/two-fa/two-fa.component';

const routes: Routes = [{
  path: '',
  component: LoginComponent
},

{
  path: 'login',
  redirectTo: 'login'
},
{
  path: 'create-Account',
  component: CreateAccountComponent
},
{
  path: 'reset-Password',
  component: ResetPwdComponent
},
{
  path: 'select-language/:pageName',
  component: SelectLangComponent
},
{
  path: 'new-password/:email',
  component: NewPasswordComponent
},
{
  path: 'asset-library',
  component: AssetLibraryComponent,
  canActivate: [AuthGuard]
},
{
  path: 'profile',
  component: ProfileTabsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'profile/update-ipos',
  component: ProfileTabsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'sku-ids',
  component: SkuIdsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'home',
  component: HomeComponent,
  canActivate: [AuthGuard]
},
{
  path: 'confirm-registration/:email',
  component: ConfirmRegistrationComponent
},
{
  path: 'account-created',
  component: AccountCreatedComponent
},
{
  path: 'profile/create',
  component: CreateProfileComponent,
  canActivate: [AuthGuard]
},
{
  path: 'profile/edit/:profileId',
  component: CreateProfileComponent,
  canActivate: [AuthGuard]
},
{
  path: 'users/retailhqs',
  component: UsersComponent,
  canActivate: [AuthGuard]
},
{
  path: 'users/stores',
  component: UsersComponent,
  canActivate: [AuthGuard]
},

{
  path: 'users/activeusers',
  component: UsersComponent,
  canActivate: [AuthGuard]
},
{
  path: 'users/pendingusers',
  component: UsersComponent,
  canActivate: [AuthGuard]
},
{
  path: 'users/domainwhiltelist',
  component: UsersComponent,
  canActivate: [AuthGuard]
},
{
  path: 'account-created/:activestatus',
  component: AccountCreatedComponent
},
{
  path: 'devices/device-dashboard',
  component: DevicesComponent,
  canActivate: [AuthGuard]
},
{
  path: 'devices/active-device-report',
  component: DevicesComponent,
  canActivate: [AuthGuard]
},
{
  path: 'devices/device-store-logo',
  component: DevicesComponent,
  canActivate: [AuthGuard]
},
{
  path: 'devices/device-settings',
  component: DevicesComponent,
  canActivate: [AuthGuard]
},
{
  path: 'oem/model-sku-info',
  component: OemPortalComponent,
  canActivate: [AuthGuard]
},

{
  path: 'oem/create-partner-content',
  component: OemPortalComponent,
  canActivate: [AuthGuard]
},

{
  path: 'oem/create-model-sku-info',
  component: NewModelSkuComponent,
  canActivate: [AuthGuard]
},
{
  path: 'oem/attractor-loop',
  component: OemPortalComponent,
  canActivate: [AuthGuard]
},
{
  path: 'oem/edit/:autoID',
  component: NewModelSkuComponent,
  canActivate: [AuthGuard]
},
{
  path: 'my-account',
  component: MyAccountComponent
},
{
  path: 'help',
  component: IposHelpComponent
},
{
  path: 'change-language',
  component: ChangeLanguageComponent,
  canActivate: [AuthGuard]
},
{
  path: 'standard-download',
  component: StandardDownloadComponent,
  canActivate: [AuthGuard]
},
{
  path: 'partner-content/review-partner-content',
  component: PartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'partner-content/approved-partner-content',
  component: PartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'partner-content/partners',
  component: PartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'partner-content/authors',
  component: PartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'partner-content/system-ids',
  component: PartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'oem/new-partner-content',
  component: NewPartnerContentComponent,
  canActivate: [AuthGuard]
},
{
  path: 'game-demos',
  component: GameDemosComponent,
  canActivate: [AuthGuard]
},
{
  path: 'unison-demo',
  component: GameDemosComponent
},
{
  path: 'two-FA',
  component: TwoFAComponent
},
{
  path: '**',
  redirectTo: ''
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
